import { AttendanceStatus } from "@/api/resources/content/types"

// TODO: Delete
export enum TeachingLevel {
  Primary = "primaryLevel",
  Middle = "middleLevel",
  Secondary = "secondaryLevel",
  Senior = "seniorLevel",
}

// TODO: Delete
export enum TeacherStatus {
  Pending = "Pending",
  Active = "Active",
}

// TODO: Delete
export type Teacher = {
  id: string
  name: string
  teachingLevel: TeachingLevel
  status?: TeacherStatus
  color: string
  totalLearningHrs: Date | null
  cpat: null
  overallProgress: number
  masterclassesAttended: {
    attended: number
    total: number
  }
}

// TODO: Delete
export type Course = {
  url: string
  name: string
  startTime: Date
  endTime: Date
  progress: number
  score: number
  timeSpent: Date
}

export type MasterclassAttendance = {
  picture?: string | null
  fullName: string
  teachingLevels?: string[]
  attendanceStatus: AttendanceStatus
  userId: string
}
